import React from 'react';

const IconLeetCode = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-code">
        <g transform="translate(12, 12) scale(1.2) translate(-12, -12)">
            <path d="M12 13h7.5" />
            <path d="M9.424 7.268l4.999 -4.999" />
            <path d="M16.633 16.644l-2.402 2.415a3.189 3.189 0 0 1 -4.524 0l-3.77 -3.787a3.223 3.223 0 0 1 0 -4.544l3.77 -3.787a3.189 3.189 0 0 1 4.524 0l2.302 2.313" />
        </g>
    </svg>
);

export default IconLeetCode;
